import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock, Users } from 'lucide-react';
import { IssueVisibility } from '@momentum/types';
import { Badge } from '@/shared/components/ui/Badge';
import { cn } from '@/shared/utils/utils';

interface VisibilityBadgeProps {
  visibility: IssueVisibility;
  size?: 'sm' | 'md';
  className?: string;
}

export const VisibilityBadge: React.FC<VisibilityBadgeProps> = ({
  visibility,
  size = 'md',
  className,
}) => {
  const { t } = useTranslation('goals');

  if (visibility === IssueVisibility.PRIVATE) {
    return (
      <div
        className={cn(
          'flex items-center text-muted-foreground gap-1',
          size === 'sm' && 'text-xs',
          className
        )}
      >
        <Lock className={cn(size === 'sm' ? 'w-3 h-3' : 'w-4 h-4')} />
      </div>
    );
  }

  return (
    <Badge
      variant="secondary"
      className={cn(
        'flex items-center gap-1',
        size === 'sm' && 'text-xs h-5',
        className
      )}
    >
      <Users className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} />
      {t('public')}
    </Badge>
  );
};
